import styled from 'styled-components';

export const BillingAddPaymentModalContainer = styled.div`
    position: relative;
    min-height: 200px;
`;

export const StyledSpinnerContainer = styled.div`
    position:absolute;
    width: 100%;
`;
